import { Component, inject, Input } from '@angular/core';
import { VoucherService, VoucherRedeemModel, BalanceService, config, ErrorStateService, LoyaltyFeed } from '@fgb/core';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'fgbcl-loyalty-feed-vouchers',
  templateUrl: './loyalty-feed-vouchers.component.html',
  styleUrls: ['./loyalty-feed-vouchers.component.scss'],
})
export class LoyaltyFeedVouchersComponent {
  voucherCode: string;
  redemptionResult: string;
  disableButton: boolean;
  sucessfulRedemption: boolean;
  @Input() feed: LoyaltyFeed;
  private messageTimeout: ReturnType<typeof setInterval>;
  private voucherService = inject(VoucherService);
  private balanceService = inject(BalanceService);
  private errorService = inject(ErrorStateService);
  private translate = inject(TranslateService);

  /* ================================
   * Public API
   * ================================ */

  redeemVoucher() {
    if (this.messageTimeout) {
      clearTimeout(this.messageTimeout);
    }
    this.clearMessages();
    this.sucessfulRedemption = false;
    this.disableButton = true;

    if (!this.voucherCode) {
      this.redemptionResult = this.translate.instant('voucher.code.empty.text');
      this.disableButton = false;
      this.clearMessagesAfter(10000);
      return;
    }

    let voucher = new VoucherRedeemModel();
    voucher.VoucherCode = this.voucherCode;
    this.voucherService
      .redeemVoucher(voucher)
      .toPromise()
      .then((item) => {
        this.balanceService.fetchBalance(config.purseConfig.virtualLoyalty).pipe(take(1)).subscribe();
        this.redemptionResult = this.translate.instant('voucher.process.code');
        this.sucessfulRedemption = true;
      })
      .finally(() => {
        this.disableButton = false;
        this.clearMessagesAfter(10000);
      });
  }

  /* ================================
   * Private Helpers
   * ================================ */

  private clearMessagesAfter(timeAfter: number) {
    this.messageTimeout = setTimeout(() => {
      this.clearMessages();
    }, timeAfter);
  }

  private clearMessages() {
    this.redemptionResult = '';
    this.errorService.clearErrors();
  }
}
